import React from 'react';
import loadable from '@loadable/component';
import { Spin } from '@arco-design/web-react';
import styles from '../style/layout.module.less';


const RELOAD_KEY = 'chunk_reload_time';

// 发版后旧 chunk 被删除会导致懒加载失败（ChunkLoadError），
// 此时强制刷新页面以获取新版本资源；10 秒内只刷新一次，避免死循环
function retryOnChunkError(fn) {
  return (...args) =>
    fn(...args).catch((error) => {
      const isChunkError =
        error?.name === 'ChunkLoadError' ||
        /Loading (CSS )?chunk .* failed/i.test(error?.message || '');
      const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || 0);

      if (isChunkError && Date.now() - lastReload > 10 * 1000) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        window.location.reload();
        // 返回一个不会 resolve 的 promise，等待页面刷新，避免闪现错误状态
        return new Promise(() => void 0);
      }
      throw error;
    });
}

// https://github.com/gregberge/loadable-components/pull/226
function load(fn, options) {
  const wrapped = retryOnChunkError(fn);
  const Component = loadable(wrapped, options);

  Component.preload = fn.requireAsync || wrapped;

  return Component;
}

function LoadingComponent(props: {
  error: boolean;
  timedOut: boolean;
  pastDelay: boolean;
}) {
  if (props.error) {
    console.error(props.error);
    return null;
  }
  return (
    <div className={styles.spin}>
      <Spin />
    </div>
  );
}

export default (loader) =>
  load(loader, {
    fallback: LoadingComponent({
      pastDelay: true,
      error: false,
      timedOut: false,
    }),
  });
